import type { ReactElement } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'
import { useSidebarOpen } from './context'

/** Names a row on the collapsed rail, where it shows its icon alone. */
export function SidebarRowTooltip({ label, children }: { label: string; children: ReactElement }) {
  const open = useSidebarOpen()
  if (open) return children

  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right" sideOffset={8}>
        {label}
      </TooltipContent>
    </Tooltip>
  )
}
